///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, OnInit } from '@angular/core';
import { ProjectService } from '../../../services/project/project.service';

import { AttachedFileDTO, DesignQuotationRequestDTO } from '../../../generated/shared-types.model';
import { ProjectWindowsPopupService } from '../project-windows-popup.service';
import { GtthDataUtils } from '../../../services/data-util.service';
import { GtthProjectStateService } from '../../logical-topology/engine/project-state.service';
import { Principal } from '../../../shared/auth/principal.service';
import { ActiveRestorableWindow } from '../active-restorable-window';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'winde-request-design-quotation-modal',
    templateUrl: './request-design-quotation-modal.component.html',
    styleUrls: ['./request-design-quotation-modal.scss'],
    standalone: false
})
export class GtthRequestDesignQuotationModalComponent extends ActiveRestorableWindow implements OnInit {
    public attachedFiles: File[];
    public isSending: boolean;
    public requestDesign: DesignQuotationRequestDTO;

    constructor(
        public dialogRef: MatDialogRef<GtthRequestDesignQuotationModalComponent>,
        private readonly principal: Principal,
        private readonly projectService: ProjectService,
        private readonly projectStateService: GtthProjectStateService
    ) {
        super();
    }

    ngOnInit() {
        this.attachedFiles = [];
        this.isSending = false;

        this.principal.identity().then((userData) => {
            this.requestDesign = {
                title: '',
                description: '',
                attachedFiles: undefined,
                customerName: this.projectStateService.getProject().customerName,
                userLogin: userData.login,
                userFullName: userData.firstName + ' ' + userData.lastName,
                projectId: this.projectStateService.getProjectId(),
                projectName: this.projectStateService.getProject().name
            } as DesignQuotationRequestDTO;
        });
    }

    closeModal() {
        this.requestDesign.title = '';
        this.requestDesign.description = '';
        this.attachedFiles = undefined;
        this.dialogRef.close('cancel');
    }

    changeFiles($event) {
        const newFiles = [];

        const fileInput: HTMLInputElement = $event.target;
        const selectedFiles: FileList = fileInput.files;

        for (let i = 0; i < selectedFiles.length; i++) {
            let isExist = false;
            const selectedFile = selectedFiles.item(i);

            for (const attachedFile of this.attachedFiles) {
                if (attachedFile.name === selectedFile.name) {
                    isExist = true;
                    break;
                }
            }

            if (!isExist) {
                newFiles.push(selectedFile);
            }
        }

        this.attachedFiles = [...this.attachedFiles, ...newFiles];
        fileInput.value = '';
    }

    removeFileFromList(file) {
        this.attachedFiles = this.attachedFiles.filter((attachedFile: File) => {
            return attachedFile.name !== file.name;
        });
    }

    sendReport() {
        this.isSending = true;

        this.requestDesign.attachedFiles = [];

        if (!this.attachedFiles || this.attachedFiles.length === 0) {
            this.projectService
                .requestDesignQuotation(this.projectStateService.getProjectId(), this.requestDesign)
                .subscribe(() => this.closeModal());
            return;
        }

        this.attachedFiles.forEach((file) => {
            GtthDataUtils.toBase64(file, (base64Data) => {
                const attachedFile: AttachedFileDTO = {
                    fileName: file.name,
                    file: base64Data,
                    contentType: file.type
                };

                this.requestDesign.attachedFiles.push(attachedFile);

                if (this.attachedFiles.length === this.requestDesign.attachedFiles.length) {
                    this.attachedFiles = undefined;
                    this.projectService
                        .requestDesignQuotation(this.projectStateService.getProjectId(), this.requestDesign)
                        .subscribe(() => this.closeModal());
                }
            });
        });
    }

    designRequired(): boolean {
        return false;
    }

    isRestorable(): boolean {
        return true;
    }
}

@Component({
    selector: 'winde-request-design-quotation-popup',
    template: '',
    standalone: false
})
export class GtthRequestDesignQuotationPopupComponent implements OnInit {
    constructor(private readonly projectWindowsPopupService: ProjectWindowsPopupService) {}

    ngOnInit() {
        this.projectWindowsPopupService.openWindow(GtthRequestDesignQuotationModalComponent, 'xl');
    }
}
